import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { TableHeaderProps, TableHeaderSortIconProperties } from '@/features/common/components/maintenance-table/types';
import { CommonSortBy } from '@/features/common/hooks/useCommonQueryParams';

const TableHeaderSortIcon = ({ display = false, sortDirection = 'ASC' }: TableHeaderSortIconProperties) => {
    if (!display) {
        return null;
    }
    return (
        <span
            className={classNames('rioglyph', sortDirection === 'ASC' ? 'rioglyph-arrow-up' : 'rioglyph-arrow-down')}
        />
    );
};
export const TableHeader = <S = CommonSortBy,>({
    columns,
    sortBy,
    sortDirection,
    handleSortChange,
    selectionHeader,
}: TableHeaderProps<S>) => {
    const renderedColumns = useMemo(() => {
        return columns.map((column) => {
            const { name, labelKey, sortingValue, sortable } = column;
            const isSorted = sortBy === name || sortBy === sortingValue;
            return (
                <th
                    key={name}
                    className={sortable ? 'sortable' : undefined}
                    onClick={sortable ? handleSortChange : undefined}
                    data-sortby={sortingValue ?? name}
                >
                    <FormattedMessage id={labelKey} />
                    {sortable && <TableHeaderSortIcon display={isSorted} sortDirection={sortDirection} />}
                </th>
            );
        });
    }, [columns, sortBy, sortDirection]);
    return (
        <thead>
            <tr>
                {selectionHeader !== undefined && <th className="select-column">{selectionHeader}</th>}
                {renderedColumns}
            </tr>
        </thead>
    );
};
